import { useState } from "react";
import Navbar from "../components/layout/NavBar";
import Footer from "../components/layout/Footer";
import Hero from "../components/sections/Hero";
import TrustStrip from "../components/sections/TrustStrip";
import ProblemSection from "../components/sections/ProblemSection";
import HowItWorks from "../components/sections/HowItWorks";
import FeatureSection from "../components/sections/FeatureSection";
import VisualInsights from "../components/sections/VisualInsights";
import WhyDifferent from "../components/sections/WhyDifferent";
import OutcomesSection from "../components/sections/OutcomesSection";
// import TestimonialsSection from "../components/sections/TestinomialsSection";
import CTABanner from "../components/sections/CTABanner";
import FAQSection from "../components/sections/FAQSection";
import useNavbarScroll from "../hooks/useNavbarScroll";
import useScrollReveal from "../hooks/useScrollReveal";
import "../styles/stockmove.css";

export default function StockMovePage() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openFaq, setOpenFaq] = useState(null);
  const navScrolled = useNavbarScroll();

  useScrollReveal();

  return (
    <div className="sm">
      <Navbar
        scrolled={navScrolled}
        mobileOpen={mobileOpen}
        setMobileOpen={setMobileOpen}
      />

      <main>
        <Hero />
        <TrustStrip />
        <ProblemSection />
        <HowItWorks />
        <FeatureSection />
        <VisualInsights />
        <WhyDifferent />
        <OutcomesSection />
        {/* <TestimonialsSection /> */}
        <CTABanner />
        <FAQSection openFaq={openFaq} setOpenFaq={setOpenFaq} />
      </main>

      <Footer />
    </div>
  );
}